module.exports = {
    "id": "flashlight",
    "title": "flashlight",
    "image": "provision/parts/flashlight/flashlight.png",
    "info": [
      {
        "text": "Add a flashlight to your project",
        "image": "provision/parts/flashlight/flashlight.png"
      }
    ],
    "exposedVariables": [
    ],
    "codeImage": "provision/parts/flashlight/flashlight.png"
  };